var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-container",
    [
      _c("app-error", { attrs: { hide: _vm.error == "" } }, [
        _vm._v(" " + _vm._s(_vm.error) + " "),
      ]),
      !_vm.complete
        ? _c(
            "app-section",
            [
              !_vm.error
                ? _c("app-text", { staticClass: "sub-welcom" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("transfering")) + " "),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _c(
            "app-section",
            { staticClass: "completed" },
            [
              _c("h1", [
                _c(
                  "div",
                  { staticClass: "complete-icon" },
                  [_c("w-fa", { attrs: { icon: ["far", "check-circle"] } })],
                  1
                ),
                _vm._v(" " + _vm._s(_vm.$ct("complete")) + " "),
              ]),
              _c("w-button", { staticClass: "mt", attrs: { to: "/" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("back-to-app")) + " "),
              ]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }